/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */
import { color as colorFn } from "@smartsheet/design-tokens-react";
import React, { CSSProperties, forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../components/icon/GeneratedIconProps";
import { Icon } from "../../components/icon/Icon";
import { getUrsaIconColorVarName } from "../../components/icon/getUrsaIconColorVarName";
import MagnifyingGlassIcon20 from "./MagnifyingGlassIcon20";
import MagnifyingGlassIcon24 from "./MagnifyingGlassIcon24";

const getSizeMap = (viewBox?: string, width?: string | number, height?: string | number) => {
    return {
        20: viewBox ? (
            <MagnifyingGlassIcon20 viewBox={viewBox} width={width ? width : 20} height={height ? height : 20} />
        ) : (
            <MagnifyingGlassIcon20 width={width ? width : 20} height={height ? height : 20} />
        ),
        24: viewBox ? (
            <MagnifyingGlassIcon24 viewBox={viewBox} width={width ? width : 24} height={height ? height : 24} />
        ) : (
            <MagnifyingGlassIcon24 width={width ? width : 24} height={height ? height : 24} />
        ),
    };
};

export interface MagnifyingGlassIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 20 | 24;
}

export const MagnifyingGlassIcon = forwardRef(
    (
        {
            // This is the default icon color.
            color = `var(${getUrsaIconColorVarName()}, ${colorFn("color--icons--neutral--strongest")})`,
            size,
            viewBox,
            width,
            height,
            style,

            ...rest
        }: MagnifyingGlassIconProps,
        ref: Ref<HTMLElement>
    ) => {
        return (
            <Icon
                color={color}
                ref={ref}
                size={size}
                width={width}
                height={height}
                {...rest}
                style={
                    {
                        ...style,
                    } as CSSProperties
                }
            >
                {getSizeMap(viewBox, width, height)[size]}
            </Icon>
        );
    }
);
MagnifyingGlassIcon.displayName = "MagnifyingGlassIcon";
